import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import {
    setConnectedUsers,
    setUserLocations,
    setTrackingStats,
    setLoading,
    setError,
    setSocketConnected,
    addConnectedUser,
    removeConnectedUser,
    updateUserLocation,
    updateTrackingStatus
} from "../../../store/tracking/trackingSlice";

const mapStateToProps = (state) => {
    return {
        trackingState: state.tracking || {
            connectedUsers: [],
            userLocations: {},
            trackingStats: {
                totalConnected: 0,
                totalStaffOnline: 0,
                lastUpdated: null
            },
            isLoading: false,
            error: null,
            socketConnected: false
        }
    };
};

const mapDispatch = {
    setConnectedUsers,
    setUserLocations,
    setTrackingStats,
    setLoading,
    setError,
    setSocketConnected,
    addConnectedUser,
    removeConnectedUser,
    updateUserLocation,
    updateTrackingStatus
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(mapDispatch, dispatch);

const Store = (Container) =>
    connect(mapStateToProps, mapDispatchToProps)(Container);

export default Store;